// extracted by mini-css-extract-plugin
export default {"especialidades":"Especialidades_especialidades__twfZA","flex":"Especialidades_flex__96IEm","especialidadesBox":"Especialidades_especialidadesBox__aQKEv"};